import Usermenu from '../components/Usermenu/Usermenu';
import Copilot from '../components/Copilot/Copilot';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header'; /* eslint-disable */

import React from 'react';
import { createScope, map, transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '$(".show-tenants").click(function(t){t.preventDefault(),$(".user-tenants").toggle()});var currentPath=window.location.pathname;"/"===currentPath&&$(\'.menu-wr[data-name="overview"]\').addClass("active");'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".left_mobile_nav_trigger").on("click",function(){$(".left_menu_mob").toggle()}),$(".link-options").click(function(){var t=$(this).attr("data-name");$(".link-options").each(function(t){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(t){$(this).removeClass("active")}),$(".panel[data-name="+t+"]").addClass("active")}),$(".layout-div").click(function(){$(".layout-div").each(function(){$(this).removeClass("active")}),$(this).addClass("active")}),$(".create-dashboard").click(function(){$(".create-report-popup").addClass("show")}),$(".cancel-create-report").click(function(){$(".create-report-popup").removeClass("show")}),$(".create-report").click(function(){$(".create-report-popup").removeClass("show")}),$(".prof_menu").click(function(){$(".prof_menu").each(function(t){$(this).removeClass("active")});var t=$(this).attr("data-name");console.log(t),$(".ov_panel").each(function(t){$(this).removeClass("active")}),$(".ov_panel[data-name="+t+"]").addClass("active"),$(this).addClass("active")}),$(".roles").click(function(){$(".roles_popup").toggle()}),$(".roles").click(function(t){t.stopPropagation()}),$(".send-message").click(function(){$(".popup_div").addClass("show"),$("body").addClass("locked")}),$(".cancel_btn").click(function(){$(".popup_div").removeClass("show"),$("body").removeClass("locked")}),$(".web-sub").not(".active").each(function(t){$(this).click(function(){$(this).children(".w_menu").toggleClass("active"),$(this).parent().addClass("active")})}),$(".downloads_trigger").click(function(){$(".download_popup").toggle()}),$(window).click(function(){$(".download_popup")[0]&&($(".download_popup")[0].style.display="none")}),$(".downloads_trigger").click(function(t){t.stopPropagation()}),$(".tp_trigger").each(function(t){$(this).on("mouseover",function(){$(".tp_content")[t].style.visibility="visible"}),$(this).on("mouseout",function(){$(".tp_content")[t].style.visibility="hidden"})}),$(".menu-wr").not(".active").each(function(t){$(this).click(function(){0<$(this).children(".submenu").length&&($(this).children(".submenu").hasClass("clicked")?$(this).children(".submenu").removeClass("clicked"):$(this).children(".submenu").addClass("clicked"),$(".submenu").not($(this).children(".submenu")).each(function(t){$(this).removeClass("clicked")}))})}),$(".mob_nav_trigger").click(function(){$(".sidebar")[0].style.display="block",$(".sidebar")[0].style.left="0px",$(".mob_sidebar_overlay")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".mob_sidebar_overlay").click(function(){$(".sidebar")[0].style.left="-230px",$(".mob_sidebar_overlay")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".mobile_menu").click(function(t){t.stopPropagation()}),$(".mobile_nav_trigger").click(function(t){t.stopPropagation()}),$(".profile_menu_trigger").click(function(){$(".prof_menu_popup").toggle()}),$(window).click(function(){$(".prof_menu_popup").each(function(t){$(this)[0].style.display="none"}),$(".roles_popup")[0].style.display="none"}),$(".profile_menu_trigger").click(function(t){t.stopPropagation()}),$(".options_trigger").each(function(t){$(this).click(function(){$(".actions").each(function(t){$(this)[0].style.display="none"}),$(".actions")[t].style.display="block"})}),$(window).click(function(){$(".actions").each(function(t){$(this)[0].style.display="none"})}),$(".options_trigger").click(function(t){t.stopPropagation()}),$(".unit-name").each(function(t){$(this).click(function(){$(this).parent().hasClass("active")?($(".unit_row")[t].classList.remove("active"),$(".minus")[t].classList.remove("active"),$(".plus")[t].classList.add("active"),$(".unit_description")[t].classList.remove("active")):($(".unit_row")[t].classList.add("active"),$(".minus")[t].classList.add("active"),$(".plus")[t].classList.remove("active"),$(".unit_description")[t].classList.add("active"))})}),$(".menu-wr.web").each(function(t){$(this).click(function(t){console.log(t.target),(t.target.classList.contains("menu-option")||t.target.classList.contains("text-block-107")||t.target.classList.contains("fa_icon")||t.target.classList.contains("menu-icon")||t.target.classList.contains("link-block-13"))&&$(this).children(".submenu").toggleClass("active")})})}),$(".export_to_csv").each(function(t){$(this).click(function(){window.open("https://docs.google.com/spreadsheets/d/e/2PACX-1vRk0PYQrq-pES_V3Gn6qgQUj6KKe5YrpKSyoJJu7cgIWRmtZjMsaxlfIMtU7RLrppLxHMVokZYenq0X/pub?output=csv","_blank")})}),$(".more-btn").click(function(){var t=$(this).attr("data-name");$(\'.more-h[data-name="\'+t+\'"]\').show(),$(this).hide()}),$(".select-field-6").on("change",function(){var t=this.value,e=$(this).closest(".div-block-202");let i=parseInt($(e).find(".text-block-110.n").attr("data-default")),n=parseInt($(e).find(".text-block-110.n").attr("data-dn")),a=("b"==$(this).attr("data-type")&&(i=345,n=345),""),c="";"lw"==t?(c=i,a=n):"lm"==t?(c=i+20,a=n+20,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"at"==t?(c=i+25,a=n+25,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"c"==t||"nm"==t?(c=i,a=n):"ny"==t?(c=i+85,a=n+85,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")):"n3y"==t&&(c=i+240,a=n+240,newPerc=Math.round((c-i)/i*100),$(e).find(".text-block-110.per").html("+"+a+" (+"+newPerc+"%)"),$(e).find(".text-block-110.per").addClass("up"),$(e).find(".image-6.caret").addClass("up").attr("src","https://assets.website-files.com/63628e2a6d1095f29b34a624/6369358bff42b16cfcc0a0cd_636934d9d5bff525e7d57ae1_arrow-up.png")),$(e).find(".text-block-110.n").html(c),$(e).find("span.dn").html(a)}),$(".text-block-107").each(function(t){"BEHAVIOR"==$(this).html()&&$(this).html("ENGAGEMENT")}),$(".select-field-7").on("change",function(){let e=$(this).val();var t,i;"c"!=e&&(i=$(this).closest(".div-block-202"),t=$(i).find(".text-block-110.sml"),i=$(i).find(".div-block-209"),$(t).each(function(t){$(this).hide()}),$(t).each(function(t){$(this).attr("data-name")==e&&$(this).show()}),$(i).each(function(t){$(this).hide()}),$(i).each(function(t){$(this).attr("data-name")==e&&($(this)[0].style.display="flex")}))}),$(".select-field-8").on("change",function(){let e=$(this).val();var t,i;"c"!=e&&(i=$(this).closest(".div-block-202"),t=$(i).find(".text-block-110.n"),i=$(i).find(".div-block-209"),$(t).each(function(t){$(this).hide()}),$(t).each(function(t){$(this).attr("data-name")==e&&$(this).show()}),$(i).each(function(t){$(this).hide()}),$(i).each(function(t){$(this).attr("data-name")==e&&($(this)[0].style.display="flex")}))}),$(".select-field-9").on("change",function(){var e=$(this).val();if("c"!=e){$(this).attr("data-type");var i=$(this).closest(".gr_div"),n=($(i).find("#sperc").html(),$(this).attr("data-def"));let t="";"lw"==e?t=+n:"lm"==e?t=+n+3:"at"==e&&(t=+n+6);e=t+"%";$(i).find("#sperc").html(e),$(i).find("#ib")[0].style.backgroundImage="conic-gradient(from 155deg, #527bcd "+t+"%, #525252 0); !important",console.log($(i).find("#ib"))}});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '!function(t){t(window).on("load",function(){t(".table_cont").mCustomScrollbar({axis:"x",theme:"light-3"}),t(".table_cont-2").mCustomScrollbar({axis:"x",theme:"light-3"}),t(".custom_slider").mCustomScrollbar({axis:"x",theme:"light-3"})})}(jQuery);'
    ),
    isAsync: false,
  },
];

let Controller;

class NotificationsView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/NotificationsController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = NotificationsView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '657af3ad1367da03b3b1260f';
    htmlEl.dataset['wfSite'] = '657af3ad1367da03b3b12527';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      NotificationsView.Controller !== NotificationsView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-ai-analytics-pro-v2.webflow.css);
          @import url(https://drive.google.com/uc?export=view&id=1DZ1X4oaKbcEoicQQ7AMublzIQKQhL2ZZ);


            .merlin.chat{
            	display:none;
            }



            .circle .inner{
                background: #272c34 !important;
              color: #fff !important;
            }
            label.switch {
              margin-bottom: 0;
          }
          .switch {
              position: relative;
              display: inline-block;
              width: 33px;
              height: 15px;
          }
            .switch input {
              opacity: 0;
              width: 0;
              height: 0;
          }
            .switch input:checked + .slider {
              background-color: rgba(82, 123, 205, 0.6);
          }
          .switch .slider.round {
              border-radius: 34px;
          }
          .switch .slider {
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #525252;
              -webkit-transition: .4s;
              transition: .4s;
          }
            .switch input:checked + .slider:before {
              background-color: rgba(82, 123, 205, 1);
          }
          .switch input:checked + .slider:before {
              -webkit-transform: translateX(16px);
              -ms-transform: translateX(16px);
              transform: translateX(16px);
          }
          .switch .slider.round:before {
              border-radius: 50%;
          }
          .switch .slider:before {
              position: absolute;
              content: \"\";
              height: 17px;
              width: 17px;
              left: 0px;
              bottom: -1px;
              background-color: white;
              -webkit-transition: .4s;
              transition: .4s;
          }
            .create-report-popup select {
            	-webkit-appearance: listbox !important
            } 
            .profile_menu .mCSB_container{
            min-width: 900px;
          }
            .profile_menu .mCustomScrollBox{
            	width:97%;
            }
          @media screen and (min-width: 1280px) {
            .sk1 .mCSB_container{
              width: auto !important;
              left:0 !important;
             }
          }
          input, textarea {
            color: #fff !important;
          }
          	body.locked{
            overflow: hidden !important;
          }
            .tp_content{
            	visibility:hidden;
            }
            .submenu.clicked{
            	display:block;
              padding: 0px;
              background-color: #383d48;
            }
            @media screen and (min-width: 991px) {
            .sidebar{
              left:0 !important;
            }
          }
            .sidebar{
            transition: 0.5s;
            }
            iframe{
            border:none !important;
            }
            .l1.tr{
            	flex-shrink:0;
            }
            .nav{
            border-image: linear-gradient( 90deg ,#0A3B63, #527bcd) 3;
          }
            #myChart2{
            	height:220px !important;
            }
           .menu-option.active {
            border-image: linear-gradient( 180deg ,#851168,#f75eef) 2;
            }
              .submenu-item.active:hover:not(.web) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
                .submenu-item.active:not(.web):not(.web-sub) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
             .submenu-item:hover:not(.active) {
            border-image: linear-gradient( 180deg ,#fff,#fff) 2;
            }
                .submenu-item:hover:not(.active) > a {
            color: #fff !important;
          }
            .link-block-13:hover:not(.active){
            border-image: linear-gradient( 180deg ,#851168,#f75eef) 2;
          }
          .link-block-13:hover:not(.active){
            color: #527bcd !important;
          }
          .link-block-13:hover:not(.active)  .text-block-107{
            color: #527bcd !important;
          }
            .link-block-13:hover:not(.active) .icon{
              display: none !important;
          }
          .link-block-13:hover:not(.active) .icon_h{
              display: inline !important;
          }
            .image-4{
              box-shadow:0 0 1px 1px #fff;
            }
            .submenu-item.active:not(.web):not(.web-sub){
              border-image: linear-gradient( 180deg ,#851168,#f75eef) 2 !important;
          }
          .link-block-12.active{
            color: #527bcd !important;
          }
          .submenu-item.web-sub:hover{
              border-color: transparent !important;
              border-image: none !important;
          }
            ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.2);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(255, 255, 255, 0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(255, 255, 255, 0.5);
          }
            .submenu-item:hover:not(.active) > a {
            color: #527bcd !important;
          }
            .submenu-item:hover:not(.active):not(.web-sub) {
              border-image: linear-gradient( 180deg ,#851168,#f75eef) 2 !important;
          }
          .tp_content.sho{
          visibility: visible;
            display:none;
          }
            .tp_content{
            	display:none;
            }
          @media screen and (max-width: 991px) {
            .real_map{
              height: 350px !important;
            }
          }
            .mob_nav {
              border-image: linear-gradient( 90deg ,#0A3B63, #527bcd) 3 !important;
          }
            .mob_nav .text-block-125{
            	display:none;
            }
            ::-webkit-scrollbar-track {
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.2) !important;
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background:  rgba(255, 255, 255, 0.4) !important;
          }
          ::-webkit-scrollbar-thumb:hover{
            background:  rgba(255, 255, 255, 0.6) !important;
          }
          ::-webkit-scrollbar-thumb:active{
            background:  rgba(255, 255, 255, 0.8) !important;
          }
              .table_cont-2::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .table_cont-2::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
                .div-block-183.w_i::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .div-block-183.w_i::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
                  .div-block-183.wr.sp::-webkit-scrollbar-track {
          border-radius: 10px;
          background: transparent !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background:  #527bcd !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb:hover{
          background:  #527bcd !important;
          }
          .div-block-183.wr.sp::-webkit-scrollbar-thumb:active{
          background:  #527bcd !important;
          }
            @media screen and (max-width: 410px) {
          	.apexcharts-legend {
          		bottom: -15% !important;
          	}
          }
            select {
            	-webkit-appearance: none;
            }
            .form-block-2 form{
            display:flex
          }
          .form-block-2 form:after {
             color: #9da5b4;
             content: \'\';
                font-family: \'Fa solid 900\', sans-serif;
            font-size:11px;
            position:relative;
            margin-left:-12px;
            z-index:1;
          }
            .select-field-6{
            	z-index:2;
            }
           .mCSB_horizontal.mCSB_inside > .mCSB_container{
            margin-bottom: 0 !important;
          }
          @media only screen and (min-width: 650px) {
            .mCSB_scrollTools_horizontal{
              display: none !important;
            }
          }
          .profile_menu .mCSB_scrollTools_horizontal{
              display: block !important;
            }
            @media only screen and (max-width: 650px) {
              	.mCSB_horizontal.mCSB_inside > .mCSB_container{
            margin-bottom: 12px !important;
          }
          .profile_menu .mCSB_horizontal.mCSB_inside > .mCSB_container {
              margin-bottom: 12px !important;
          }
          }
            @media screen and (max-width: 620px) {
            .real_map{
              height: 49vw !important;
            }
          }
          @media screen and (max-width: 450px) {
            .real_map{
              height: 47vw !important;
            }
          }
            .grid-2 .table_cont-2{
            	margin-bottom:0 !important;
            }
            .tp_trigger:hover .tp_content{
            display: block;
            visibility: visible
          }
            body{
            	min-width:0 !important;
            	}
            .main-content{
            	    min-height: calc(100vh - (65.5px + 88px));
            }
            @media screen and (max-width: 1330px) {
            .div-block-285._4-items{
              grid-template-columns: 1fr 1fr;
            }
          }
              @media screen and (max-width: 767px) {
            .div-block-285._4-items{
              grid-template-columns: 1fr;
            }
          }
            @media only screen and (min-width: 1625px) {
          .profile_menu .mCSB_scrollTools_horizontal{
                display: none !important;
              }
            }
          .profile_menu .mCSB_horizontal.mCSB_inside > .mCSB_container {
              margin-bottom: 12px !important;
          }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="w-layout-hflex fullpage-container">
              <div className="w-layout-vflex webpage-container">
                <Header></Header>
                <div className="mob_nav">
                  <div className="div-block">
                    <div className="mob_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                    </div>
                    <a
                      className="link-block-17 w-inline-block"
                      href="index.html"
                    >
                      <img
                        alt=""
                        className="image mob-logo"
                        loading="lazy"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 34vw, (max-width: 991px) 202.1640625px, 100vw"
                        src="images/ibl-logos--copy_1.png"
                        srcset="images/ibl-logos--copy_1-p-500.png 500w, images/ibl-logos--copy_1-p-800.png 800w, images/ibl-logos--copy_1-p-1080.png 1080w, images/ibl-logos--copy_1-p-1600.png 1600w, images/ibl-logos--copy_1-p-2000.png 2000w, images/ibl-logos--copy_1.png 2245w"
                      />
                    </a>
                    <div className="s-input">
                      <div className="form-block-4 w-form">
                        <form
                          className="form"
                          data-name="Email Form 4"
                          data-wf-element-id="568bac3c-da8e-db57-58f5-e56bfc43dece"
                          data-wf-page-id="657af3ad1367da03b3b1260f"
                          id="email-form-4"
                          method="get"
                          name="email-form-4"
                        >
                          <div className="div-block-245">
                            <input
                              className="text-field-2 w-input"
                              data-name="Name 2"
                              id="name-2"
                              maxLength={256}
                              name="name-2"
                              placeholder=""
                              type="text"
                            />
                            <div className="div-block-246">
                              <div className="text-block fa_icon mg"></div>
                            </div>
                          </div>
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="left_mobile_nav_trigger">
                      <div className="text-block-134 fa_icon"></div>
                      <img
                        alt=""
                        className="image-4 hidden"
                        loading="lazy"
                        prop-attr-names="src"
                        prop-attr-value-src="userpic"
                        src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                      />
                      <div className="text-block fa_icon arrow no-mr hidden">
                        
                      </div>
                    </div>
                  </div>
                  <div className="div-block-355 left_menu_mob">
                    <div className="div-block-3">
                      <div className="div-block-2 mt-reduced">
                        <a className="ai-skills-btn w-inline-block" href="#">
                          <div className="text-block-130">AI Skills</div>
                        </a>
                      </div>
                      <div className="div-block-2">
                        <a className="link-block-18 w-inline-block" href="#">
                          <div className="text-block-130">Downloads</div>
                        </a>
                      </div>
                      <div className="div-block-2 hidden">
                        <div className="notifications_trigger">
                          <a
                            aria-current="page"
                            className="link-block-18 w-inline-block w--current"
                            href="notifications.html"
                          >
                            <div className="text-block-130">Notifications</div>
                          </a>
                        </div>
                      </div>
                      <div className="div-block-2 nav-field hidden">
                        <div className="roles">
                          <img
                            alt=""
                            className="user-img nb"
                            loading="lazy"
                            src="images/setting_1setting.png"
                          />
                          <div className="text-block-130 sp">Roles</div>
                          <div className="text-block fa_icon arrow"></div>
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                          <div className="roles_popup">
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Admin
                              </a>
                            </div>
                            <div className="div-block-195">
                              <a className="link-2" href="#">
                                Instructor
                              </a>
                            </div>
                            <div className="div-block-195 last">
                              <a className="link-2" href="#">
                                Editor
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Usermenu></Usermenu>
                    </div>
                  </div>
                </div>
                <div className="main">
                  <div className="sidebar">
                    <div className="wrapper">
                      <div className="mob_sidebar_logo">
                        <a className="link-block-17 w-inline-block" href="#">
                          <img
                            alt=""
                            className="image mob"
                            loading="lazy"
                            sizes="(max-width: 767px) 162.9375px, (max-width: 991px) 194px, 100vw"
                            src="images/ibl-logos--copy_1.png"
                            srcset="images/ibl-logos--copy_1-p-500.png 500w, images/ibl-logos--copy_1-p-800.png 800w, images/ibl-logos--copy_1-p-1080.png 1080w, images/ibl-logos--copy_1-p-1600.png 1600w, images/ibl-logos--copy_1-p-2000.png 2000w, images/ibl-logos--copy_1.png 2245w"
                          />
                        </a>
                      </div>
                      <div className="menu-wr active">
                        <div className="menu-wr">
                          <a
                            className="link-block-19 w-inline-block"
                            href="index.html"
                          >
                            <div className="menu-option active first">
                              <div className="menu-icon">
                                <img
                                  alt=""
                                  className="icon"
                                  loading="lazy"
                                  src="images/62b33c1182cd9cbdcc8a0da1_62b1ddfcac0d91564ba2a3eb_ibl_logo_162b33c1182cd9cbdcc8a0da1_62b1ddfcac0d91564ba2a3eb_ibl_logo.png"
                                />
                                <img
                                  alt=""
                                  className="icon_h"
                                  loading="lazy"
                                  src="images/62bc49316fcb819a85489090_62b33c1182cd9cbdcc8a0da1_62b1ddfcac0d91564ba2a3eb_ibl_logo_162bc49316fcb819a85489090_62b33c1182cd9cbdcc8a0da1_62b1ddfcac0d91564ba2a3eb_ibl_logo.png"
                                />
                              </div>
                              <div>
                                <div className="text-block-107">OVERVIEW</div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">AUDIENCE</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="registered-users.html"
                            >
                              <div className="text-block-108">
                                REGISTERED USERS
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="active-users.html"
                            >
                              <div className="text-block-108">ACTIVE USERS</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="enrollments.html"
                            >
                              <div className="text-block-108">ENROLLMENTS</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="unenrollments.html"
                            >
                              <div className="text-block-108">
                                UNENROLLMENTS
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">DEMOGRAPHICS</div>
                            </a>
                          </div>
                          <div className="submenu-item hidden">
                            <a
                              className="link-block-12 w-inline-block"
                              href="https://ibl-analytics.webflow.io/geography"
                            >
                              <div className="text-block-108">GEOGRAPHY</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">ENGAGEMENT</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="course-completion.html"
                            >
                              <div className="text-block-108">
                                COURSE COMPLETION
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="time-spent.html"
                            >
                              <div className="text-block-108">TIME SPENT</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">
                                WATCHED VIDEOS
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">
                                ACTIVITY BY HOUR
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">
                                ACTIVITY BY DATE
                              </div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">
                                ACTIVITY BY CATEGORY
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">PERFORMANCE</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="grading.html"
                            >
                              <div className="text-block-108">GRADING</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">SUBMISSIONS</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="credentials.html"
                            >
                              <div className="text-block-108">CREDENTIALS</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">SKILLS</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="skills/summary.html"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="skills/overview.html"
                            >
                              <div className="text-block-108">OVERVIEW</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="skills/inventory.html"
                            >
                              <div className="text-block-108">INVENTORY</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">FINANCIAL</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="financial/summary.html"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="financial/revenue.html"
                            >
                              <div className="text-block-108">REVENUE</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="financial/products.html"
                            >
                              <div className="text-block-108">PRODUCTS</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="financial/customers.html"
                            >
                              <div className="text-block-108">CUSTOMERS</div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr web">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">WEB</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="web/dashboard.html"
                            >
                              <div className="text-block-108">DASHBOARD</div>
                            </a>
                          </div>
                          <div className="submenu-item web-sub">
                            <a
                              className="link-block-12 w_sb w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">VISITORS</div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </a>
                            <div className="submenu w_menu">
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/overview.html"
                                >
                                  <div className="text-block-108">Overview</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/visits-log.html"
                                >
                                  <div className="text-block-108">
                                    Visits Log
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/realt-time.html"
                                >
                                  <div className="text-block-108">
                                    Real-time
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/real-time-map.html"
                                >
                                  <div className="text-block-108">
                                    Real-time Map
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/locations.html"
                                >
                                  <div className="text-block-108">
                                    Locations
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/devices.html"
                                >
                                  <div className="text-block-108">Devices</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/software.html"
                                >
                                  <div className="text-block-108">Software</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/times.html"
                                >
                                  <div className="text-block-108">Times</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/visitors/user-ids.html"
                                >
                                  <div className="text-block-108">User IDs</div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="submenu-item web-sub">
                            <a
                              className="link-block-12 w_sb w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">BEHAVIOUR</div>
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </a>
                            <div className="submenu w_menu">
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/pages.html"
                                >
                                  <div className="text-block-108">Pages</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/entry-pages.html"
                                >
                                  <div className="text-block-108">
                                    Entry Pages
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/exit-pages.html"
                                >
                                  <div className="text-block-108">
                                    Exit Pages
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/page-titles.html"
                                >
                                  <div className="text-block-108">
                                    Page Titles
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/site-search.html"
                                >
                                  <div className="text-block-108">
                                    Site Search
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/outlinks.html"
                                >
                                  <div className="text-block-108">Outlinks</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/downloads.html"
                                >
                                  <div className="text-block-108">
                                    Downloads
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/events.html"
                                >
                                  <div className="text-block-108">Events</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/contents.html"
                                >
                                  <div className="text-block-108">Contents</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/engagement.html"
                                >
                                  <div className="text-block-108">
                                    Engagement
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/transitions.html"
                                >
                                  <div className="text-block-108">
                                    Transitions
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/behavior/performance.html"
                                >
                                  <div className="text-block-108">
                                    Performance
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="submenu-item web-sub">
                            <a
                              className="link-block-12 w_sb w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">ACQUISITION</div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </a>
                            <div className="submenu w_menu">
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/all-channels.html"
                                >
                                  <div className="text-block-108">
                                    All Channels
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/search-engines-keywords.html"
                                >
                                  <div className="text-block-108">
                                    Search Engines &amp; Keywords
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/websites.html"
                                >
                                  <div className="text-block-108">Websites</div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/social-networks.html"
                                >
                                  <div className="text-block-108">
                                    Social Networks
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/campaigns.html"
                                >
                                  <div className="text-block-108">
                                    Campaigns
                                  </div>
                                </a>
                              </div>
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/acquisition/campaign-url-builder.html"
                                >
                                  <div className="text-block-108">
                                    Campaign URL Builder
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="submenu-item web-sub">
                            <a
                              className="link-block-12 w_sb w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108 active">GOALS</div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </a>
                            <div className="submenu w_menu">
                              <div className="submenu-item">
                                <a
                                  className="link-block-12 w-inline-block"
                                  href="web/goals/overview.html"
                                >
                                  <div className="text-block-108">Overview</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="menu-wr">
                        <a className="link-block-13 w-inline-block" href="#">
                          <div className="menu-option">
                            <div className="menu-icon">
                              <div className="text-block fa_icon"></div>
                            </div>
                            <div>
                              <div className="text-block-107">PER LEARNER</div>
                            </div>
                            <div className="submenu_arrow">
                              <div className="text-block fa_icon up_arrow">
                                
                              </div>
                              <div className="text-block fa_icon down_arrow active">
                                
                              </div>
                            </div>
                          </div>
                        </a>
                        <div className="submenu">
                          <div className="submenu-item sum">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">SUMMARY</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-108">AT RISK</div>
                            </a>
                          </div>
                          <div className="submenu-item">
                            <a
                              className="link-block-12 w-inline-block"
                              href="learners.html"
                            >
                              <div className="text-block-108">LEARNERS</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mob_sidebar_overlay"></div>
                  <div className="main-content">
                    <div className="div-block-253">
                      <div className="div-block-205">
                        <div className="div-block-255"></div>
                        <div className="text-block-154">NOTIFICATIONS</div>
                      </div>
                    </div>
                    <div className="table_cont-2">
                      <div className="div-block-252">
                        <div className="table alert">
                          <div className="th">
                            <div className="tc">
                              <div className="w_sort">
                                <div className="sm alert_h">Description</div>
                              </div>
                            </div>
                            <div className="tc">
                              <div className="w_sort">
                                <div className="sm alert_h">Type</div>
                              </div>
                            </div>
                            <div className="tc">
                              <div className="w_sort">
                                <div className="sm alert_h">Notifies</div>
                              </div>
                            </div>
                            <div className="tc">
                              <div className="w_sort">
                                <div className="sm alert_h">State</div>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">New Enrollment</div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Alert</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">New Unenrollment</div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Alert</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">
                                New Student At Risk
                              </div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Alert</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">New Sale</div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Alert</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">Overview Report</div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Reminder</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="tr">
                            <div className="tc tcell w_not alert">
                              <div className="m s alert">Total Revenue</div>
                              <img
                                alt=""
                                className="not_tooltip"
                                loading="lazy"
                                src="images/info-1_1info-1.png"
                              />
                            </div>
                            <div className="tc tcell alert">
                              <div className="m alert">Reminder</div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="div-block-257">
                                <div className="div-block-258">
                                  <div className="m alert">Admin</div>
                                </div>
                              </div>
                            </div>
                            <div className="tc tcell alert">
                              <div className="w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
	.af-view .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
  margin-bottom:0 !importnat;
}
.af-view .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.af-view .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view .slider:before {
  position: absolute;
  content: \"\";
  height: 21px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.af-view input:checked + .slider {
  background-color: #527bcd;
}
.af-view input:focus + .slider {
  box-shadow: 0 0 1px #527bcd;
}
.af-view input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
 `,
                                  }}
                                />
                                <label className="switch">
                                  <input defaultchecked="" type="checkbox" />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
            {/*<Copilotlauncher></Copilotlauncher>*/}
          </div>
        </span>
      </span>
    );
  }
}

export default NotificationsView;

/* eslint-enable */
